import { Button, Form, Modal, Radio, RadioChangeEvent, Row, Space } from "antd";
import React, { useEffect, useState } from "react";
import Icon from "assets/icons";
import "./ModalOption.scss";
import ModalPrint from "./ModalPrint/ModalPrint";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setIsInPayTab } from "redux/reducer/reduxCommon";

const ModalOption = ({ isShowModal, handleOk, handleCancel }) => {
  const [value, setValue] = useState(1);
  const [isShowModalPrint, setIsShowModalPrint] = useState(false);
  const [phuThu, setPhuThu] = useState(true);
  const isInPayTab = useAppSelector((e) => e.reduxCommon.isInPayTab);

  useEffect(() => {
    if (isInPayTab) {
      setIsShowModalPrint(true);
    }
  }, [isInPayTab]);
  const onChange = (e: RadioChangeEvent) => {
    // console.log('radio checked', e.target.value);
    setValue(e.target.value);
    if (e.target.value == 1) {
      setPhuThu(true);
    } else {
      setPhuThu(false);
    }
  };
  useEffect(() => {
    if (value == 1) {
      setPhuThu(true);
    } else {
      setPhuThu(false);
    }
  }, [value, isShowModalPrint]);

  const handleOnPrint = () => {
    setIsShowModalPrint(true);
  };
  const dispatch = useAppDispatch();
  const handleOpen = () => {
    setIsShowModalPrint(false);
    dispatch(setIsInPayTab(false));
  };

  const handleCancelPrint = () => {
    setIsShowModalPrint(false);
    dispatch(setIsInPayTab(false));
  };

  return (
    <Modal
      title="Chọn loại bảng kê"
      centered
      open={isShowModal}
      onCancel={handleCancel}
      width={800}
      className="modal-print-option"
      footer=""
    >
      <div>
        <Row>
          <Radio.Group onChange={onChange} value={value}>
            <Space>
              <Radio
                className={
                  value == 1
                    ? "radio-button border-select"
                    : "radio-button border-radio"
                }
                value={1}
              >
                Bảng kê có phụ thu
              </Radio>
              <Radio
                className={
                  value == 2
                    ? "radio-button border-select"
                    : "radio-button border-radio"
                }
                value={2}
              >
                Bảng kê không có phụ thu
              </Radio>
            </Space>
          </Radio.Group>
        </Row>
        <Row gutter={[16, 8]} justify={"end"} style={{ marginTop: "15px" }}>
          <Space>
            <Button key="cancel" type="primary" danger onClick={handleCancel}>
              Huỷ bỏ
            </Button>
            <Button
              type="text"
              className="btn-sub"
              onClick={handleOnPrint}
              icon={<Icon.printer />}
            >
              In bảng kê
            </Button>
          </Space>
        </Row>
      </div>

      <ModalPrint
        isShowModal={isShowModalPrint}
        handleOk={handleOpen}
        handleCancel={handleCancelPrint}
        coPhuThu={phuThu}
      ></ModalPrint>
    </Modal>
  );
};

export default ModalOption;
